import { render, staticRenderFns } from "./BloggerRanking.vue?vue&type=template&id=938de19c&"
import script from "./BloggerRanking.vue?vue&type=script&lang=js&"
export * from "./BloggerRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports